module.exports = __webpack_public_path__ + "static/media/den.8f29fb7c.png";